// @flow
import React from "react";
import { withGlobalContext } from "../../../common/GlobalContext";
import withStyles from "elevate-ui/withStyles";
import Typography from "elevate-ui/Typography";
import BackgroundSlider from "react-background-slider";

import HeaderSearch from "../HeaderSearch";

import type { $Agent, $Site, $SiteOffice, $Team } from "flow/types";

type $Props = {
  agent: $Agent,
  classes: Object,
  site: $Site,
  office: $SiteOffice,
  team: $Team,
  backgroundImage: string,
  backgroundImages?: Array<string>,
  isCanadian: Function,
};

const BackgroundTransparentSearch = (props: $Props) => {
  const {
    agent,
    classes,
    backgroundImage,
    backgroundImages,
    isCanadian,
  } = props;

  const renderHeadline = () => {
    const { agent, site, team, office } = props;
    if (site.userId && agent) {
      return agent.fullName;
    } else if (site.teamId && team) {
      return team.name;
    } else if (site.officeId && office) {
      return office.name;
    } else {
      return "";
    }
  };

  const innerPortion = (
    <div>
      <Typography
        type="heading2"
        color="#fff"
        style={{ textAlign: "center", marginBottom: "2px" }}
      >
        {renderHeadline()}
      </Typography>
      {agent &&
        agent.title && (
          <Typography
            type="heading5"
            color="#fff"
            style={{ textAlign: "center", marginTop: "0" }}
          >
            {agent.title}
          </Typography>
        )}
      <div className={classes.searchBarContainer}>
        <div className={classes.innerSearchBar}>
          <HeaderSearch showColorButtons={false} isCanadian={isCanadian()} />
        </div>
      </div>
    </div>
  );

  if (backgroundImages && backgroundImages.length > 1) {
    return (
      <div className={classes.rootImages}>
        <div className={classes.backgroundImagesOverlay}>
          <BackgroundSlider
            images={backgroundImages}
            duration={5}
            transition={2}
          />

          {innerPortion}
        </div>
      </div>
    );
  }

  return (
    <div
      className={classes.root}
      style={{
        background: `linear-gradient(rgba(20, 20, 20, 0.4), rgba(20, 20, 20, 0.4)), url(${backgroundImage}) center/cover no-repeat`,
      }}
    >
      {innerPortion}
    </div>
  );
};

const styles = (theme) => ({
  root: {
    display: "flex",
    position: "relative",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "50vh",
    paddingBottom: theme.spacing.unit * 8,
  },
  rootImages: {
    display: "flex",
    position: "relative",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "50vh",
    paddingBottom: theme.spacing.unit * 8,
  },
  backgroundImagesOverlay: {
    backgroundColor: "#00000050",
    width: "100%",
    minHeight: "50vh",
    display: "flex",
    position: "relative",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    paddingBottom: theme.spacing.unit * 8,
  },
  searchBarContainer: {
    position: "absolute",
    bottom: "0",
    left: "0",
    width: "100%",
    padding: "0 24px",
    backgroundColor: "rgba(255,255,255,.3)",
  },
  innerSearchBar: {
    position: "relative",
    width: "100%",
    maxWidth: "500px",
    margin: "24px auto",
    zIndex: theme.zIndex.dropdown,
  },
});

export default withGlobalContext(
  withStyles(styles)(BackgroundTransparentSearch)
);
